<h3>Inbound Fax Queue</h3>
<div novalidate class="container-fluid p-1 mt-2 px-3 border rounded bg-light">
  <form>
    <div class="row mt-2">
      <div class="col-3">
        <app-client-select
          name="clientIds"
          placeholder="Filter by Client"
          [multiple]="true"
          [autoLoad]="true"
          [listFilters]="{ applicableToReferralClaims: true }"
          [(selectedIds)]="filters.selectedClientIds"
          (changed)="onFilterChange()"
        />
      </div>
      <div class="col-3">
        <ng-select
          class="w-100"
          bindValue="id"
          bindLabel="fullName"
          name="assignedToIds"
          placeholder="Filter by Assigned Users"
          [multiple]="true"
          [items]="assignedToUsers"
          (remove)="onFilterChange()"
          (change)="onFilterChange()"
          [(ngModel)]="filters.selectedAssignedToIds"
          />
      </div>
      <div class="col-3">
        <ng-select
          class="w-100"
          bindValue="id"
          bindLabel="username"
          name="assignedClientLeadIds"
          placeholder="Filter by Assigned Client Lead"
          [multiple]="true"
          [items]="assignedClientLeadsFilterOptions"
          (remove)="onFilterChange()"
          (change)="onFilterChange()"
          [(ngModel)]="filters.assignedClientLeadIds"
          />
      </div>
      <div class="col-3">
        <ng-select
          class="w-100"
          bindValue="value"
          bindLabel="display"
          name="statuses"
          placeholder="Filter by Status"
          [multiple]="true"
          [items]="faxStatuses"
          (remove)="onFilterChange()"
          (change)="onFilterChange()"
          [(ngModel)]="filters.selectedStatuses"
          />
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-8">
        <div class="d-flex align-items-center">
          <div class="col-auto px-1">
            Include Archived:
            <mat-slide-toggle
              name="includeArchived"
              [color]="'primary'"
              [(ngModel)]="filters.includeArchived"
              [disableRipple]="true"
              (change)="onFilterChange()"
              />
          </div>
          <div class="col-auto px-1">
            Remove Pilot Clients:
            <mat-slide-toggle
              name="excludeDirectUserAssignmentWorkflowClients"
              [color]="'primary'"
              [(ngModel)]="filters.excludeDirectUserAssignmentWorkflowClients"
              [disableRipple]="true"
              (change)="onFilterChange()"
              />
          </div>
        </div>
      </div>
      <div class="col-4">
        <div class="d-flex flex-row justify-content-end">
          <div class="col-auto d-flex align-items-center">
            Sort:
          </div>
          <div class="col-md-7 mx-1">
            <ng-select
              class="w-100"
              name="sort"
              bindValue="value"
              bindLabel="display"
              [multiple]="false"
              [items]="sortOptions"
              [clearable]="false"
              [searchable]="false"
              (change)="onSortChange()"
              [(ngModel)]="sort.dir"
            />
          </div>
          <a routerLink="/capture-admin/communications/inbound-faxes/upload" class="btn btn-primary">Upload</a>
        </div>
      </div>
    </div>
  </form>
</div>
@if (!loading) {
  <div class="mt-2">
    @if (inboundFaxes.length > 0) {
      <section>
        <app-pagination-header
          [label]="'faxes'"
          [paging]="paging"
          (pageSizeChange)="onPageSizeChange($event)"
          [includeResetFiltersButton]="true"
          (resetFiltersClick)="onResetFiltersClick()"
          />
        <table class="table table-bordered table-hover">
          <thead class="table-dark">
            <tr>
              <th>CLIENT</th>
              <th>STATUS</th>
              <th class="text-nowrap">RECEIVED AT</th>
              <th>FROM</th>
              <th class="text-center">PAGES</th>
              <th>PATIENT</th>
              <th>PRESCRIBER</th>
              <th>ASSIGNED TO</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            @for (inboundFax of inboundFaxes; track inboundFax; let i = $index) {
              <tr>
                <td>{{ inboundFax.client.humanizedName }}</td>
                <td>{{ inboundFax.status | faxStatus }}{{ inboundFax.archivedAt ? '(ARCHIVED)' : '' }}</td>
                <td class="text-nowrap">{{ inboundFax.receivedAt | date: 'MM/dd/yyyy hh:mm a' }}</td>
                <td class="text-nowrap">
                  <fa-icon [icon]="['fas', 'fax']" size="sm" />
                  <app-phone-number [number]="inboundFax.callerNumber" [noValue]="'UNKNOWN CALLER'" />
                </td>
                <td class="text-center">{{ inboundFax.pages | number }}</td>
                <td><app-patient-name [patient]="inboundFax.patient" [showAlternateNames]=false /></td>
                <td><app-prescriber-name [provider]="inboundFax.provider" /></td>
                <td>{{ inboundFax.assignedTo?.fullName }}</td>
                <td>
                  <ul class="nav">
                    <li class="nav-item"><a class="nav-link" href="#" (click)="download($event, inboundFax)"> DOWNLOAD </a></li>
                    <li class="nav-item">
                      <a class="nav-link" routerLink="/capture-admin/communications/inbound-faxes/{{inboundFax.id}}" (click)="onViewClick(i)">
                        VIEW
                      </a>
                    </li>
                    <li class="nav-item">
                      <app-user-presence category="fax" [targetId]="inboundFax.id" />
                    </li>
                  </ul>
                </td>
              </tr>
            }
          </tbody>
        </table>
        <app-pagination [paging]="paging" (pageChange)="onPageChange($event)" />
      </section>
    } @else {
      <section><p>There are no faxes.</p></section>
    }
  </div>
} @else {
  <mat-spinner />
}
